import { render, staticRenderFns } from "./suggestionsList.vue.html?vue&type=template&id=48bec798&"
import script from "./suggestionsList.ts?vue&type=script&lang=ts&"
export * from "./suggestionsList.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports